// src/com/rtd_term_pos/RtdTermPosNoReport.js
import React, { useEffect, useState } from 'react';
import { Box } from '@mui/system';
import { styled } from '@mui/material/styles';
import {
    DialogContent, Button, DialogActions,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done'; // close the dialog.
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom'; // 위치보고 지연 차량 필터링
import { AppWord, AppStyle } from '../../value/AppConst';
import DraggableViewer from '../../common/DraggableViewer';
import { rtdTermPosListNoReportRepo } from '../../value/AppModel';
import FlexyTable from '../../common/flexytable/FlexyTable';
import { useReactiveVar } from '@apollo/client';
import { RtdTermPosDictionary } from './RtdTermPosDict';

const ContentBox = styled(Box)({
    maxHeight: '75vh', minHeight:'60vh',
    display: 'flex', flexDirection: 'column', 
});

const ControlBox = styled(Box)({display:'flex', alignItems:'center', paddingBottom: 10});

const DaysByNumber = [
    '오늘 내내 위치보고 없는 차량', // 0
    '어제 자정부터 위치보고 없는 차량', // 1
    '그제 자정부터 위치보고 없는 차량', // 2
]; // 그 이상의 숫자는 ${n}일 전부터 위치보고 없는 차량

export default function RtdTermPosNoReport({
    open,
    onClose
}) {
    const rtdTermPosListNoReportData = useReactiveVar(rtdTermPosListNoReportRepo);
    const [headerText, setHeaderText] = useState('');

    useEffect(()=>{
        if(open) {
            const daysAgo = rtdTermPosListNoReportData.daysAgo > 0 ? 0 : rtdTermPosListNoReportData.daysAgo;
            const plus = -1 * daysAgo;
            if(plus < DaysByNumber.length) {
                setHeaderText(DaysByNumber[plus]);
            }
            else {
                setHeaderText(`${plus}일 전부터 위치보고 없는 차량`);
            }
        }
    }, [open, rtdTermPosListNoReportData]);

    const tableWidth = RtdTermPosDictionary.tableNoReportProps.columns.reduce((acc, cur) => acc + cur.width, 80);

    return (
        <DraggableViewer
            open={open}
            onClose={onClose}
            maxWidth='lg'
            title='위치보고 지연 차량'
            startIcon={<HourglassBottomIcon fontSize={AppWord.LARGE} />}
        >
            <DialogContent>
                <ContentBox minWidth={tableWidth}>
                    <ControlBox>
                        <strong>{headerText}</strong>
                    </ControlBox>
                    <FlexyTable
                        name={RtdTermPosDictionary.tableNoReportProps.tableId}
                        tableProps={RtdTermPosDictionary.tableNoReportProps}
                        records={rtdTermPosListNoReportData.records}
                        tools={[]}
                    />
                </ContentBox>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color={AppStyle.mui.primary}
                    variant={AppStyle.mui.contained}
                    startIcon={<DoneIcon />}
                >
                    닫기
                </Button>
            </DialogActions>
        </DraggableViewer>
    )
}